<nb-card class="h-100 w-100 mb-0">
    <nb-card-body>
        <div class="w-100 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <ng-content select="kno2-navigate-back-button"></ng-content>
                <ng-content></ng-content>

                @if (titleText) {
                    <p class="mb-0 text-muted d-flex align-items-center">
                        <ng-container *ngTemplateOutlet="titleIcon"></ng-container>
                        @if (titleText) {
                            <span class="action-bar-title">
                                {{ titleText }}
                            </span>
                        }
                    </p>
                }

                @if (titleRef) {
                    <ng-container *ngTemplateOutlet="titleIcon"></ng-container>
                    <ng-container *ngTemplateOutlet="titleRef"></ng-container>
                }
            </div>

            <div class="d-flex align-items-center">
                <ng-container *ngTemplateOutlet="contentCenter"></ng-container>
            </div>

            <div class="d-flex align-items-center">
                <ng-container *ngTemplateOutlet="contentRight"></ng-container>
            </div>
        </div>
    </nb-card-body>
</nb-card>
